import React, { useEffect, useState } from 'react'
import { 
  Dialog, DialogActions, DialogContent, DialogTitle,
  Typography, Grid, Button, makeStyles, Divider, Tabs, Tab,
} from '@material-ui/core'
import 'moment/locale/pt-br'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useMobileScreen } from '~/helpers/useMediaQuery'
import { Creators as EquipmentActions } from '~/store/ducks/equipment'
import OverlayLoading from '~/components/OverlayLoading'
import TabPanel from '~/components/TabPanel'
import EquipmentFormTab from './EquipmentFormTab'
import EquipmentHistoryFormTab from './EquipmentHistoryFormTab'
import styles from './styles'

const useStyles = makeStyles(styles)
const equipmentSelector = ({ equipment }) => equipment

const EquipmentsDialog = ({ open, onClose, id }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const equipment = useSelector(equipmentSelector)
  const isMobileScreen = useMobileScreen()

  const { loading } = equipment

  const isEdit = !!id

  const [currentTab, setCurrentTab] = useState(0)
  const handleTabsChange = (_, value) => {
    setCurrentTab(value)
  }

  useEffect(() => {
    if (isEdit && open) {
      // reset(defaultValues)
      dispatch(EquipmentActions.getEquipmentRequest(id))
      dispatch(EquipmentActions.getEquipmentDealershipsRequest())
      dispatch(EquipmentActions.getEquipmentUsersRequest())
      dispatch(EquipmentActions.getEquipmentEquipmentsTypesRequest())
      dispatch(EquipmentActions.getEquipmentHistoryRequest(id))
    }

    return () => {
      setCurrentTab(0)
    }
  }, [isEdit, id, open])

  


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isMobileScreen}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">
          {isEdit ? 'Editar ' : 'Adicionar '}
          Equipamento
        </Typography>
      </DialogTitle>
      <Divider className={classes.divider} />
      {!isEdit && (
        <>
          <Grid container className={classes.subtitleWrapper}>
            <Grid item xs={12}>
              <Typography variant="h5">Novo Equipamento</Typography>
            </Grid>
          </Grid>
          <Divider className={classes.dividerBottom} />
        </>
      )}

      <DialogContent className={classes.dialogContent}>
        {loading && <OverlayLoading />}
        {!loading && (
          <>
            <Tabs
              variant="fullWidth"
              value={currentTab}
              onChange={handleTabsChange}
            >
              <Tab label="Equipamento" />
              <Tab label="Histórico" disabled={!isEdit} />
            </Tabs>
            <TabPanel index={0} value={currentTab}>
              <EquipmentFormTab initialValues={equipment} id={id} onClose={onClose} />
            </TabPanel>
            <TabPanel index={1} value={currentTab}>
              <EquipmentHistoryFormTab id={id} onClose={onClose} />
            </TabPanel>
          </>
        )}
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions className={classes.buttonForm}>
        <Button onClick={onClose} variant="contained">
          CANCELAR
        </Button>
        <Button
          color="primary"
          type="submit"
          form="form-equipment"
          variant="contained"
        >
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  )
}

EquipmentsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number,
}

EquipmentsDialog.defaultProps = {
  id: null,
}

export default EquipmentsDialog
